export default __webpack_public_path__ + "static/media/logo.40dea4b8.png";